/* JAYKEI home banner: parallax media + left-to-right draw of the dashed curve. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initParallax(hero) {
    var media = hero.querySelector('.jk-hero__media');
    if (!media || reduced) return;
    if (hero.dataset.parallax === 'off') return;

    hero.dataset.parallax = 'on';
    var range = parseFloat(getComputedStyle(hero).getPropertyValue('--jk-hero-parallax')) || 100;
    var ticking = false;
    var visible = false;

    function apply() {
      ticking = false;
      if (!visible) return;
      var rect = hero.getBoundingClientRect();
      // How far the hero has scrolled past the top of the viewport. Zero while the
      // hero top is still at or below the viewport top, so at rest the image sits
      // exactly where Figma puts it - no downward push on first paint.
      var scrolled = Math.max(0, -rect.top);
      // Travels downward only, into the 149px it already overhangs above; a negative
      // offset would lift its bottom edge and open a gap. Reaches `range` just as the
      // hero finishes leaving the viewport.
      var y = Math.min(scrolled * (range / rect.height), range);
      // written as a variable so it composes with the fixed Figma offset in CSS
      media.style.setProperty('--jk-py', y.toFixed(2) + 'px');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    // only run the handler while the hero is actually on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) apply();
      }, { rootMargin: '100px' }).observe(hero);
    } else {
      visible = true;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  function initCurve(hero) {
    var curve = hero.querySelector('.jk-hero__curve');
    if (!curve) return;
    if (reduced || !('IntersectionObserver' in window)) return;  // CSS leaves it visible

    curve.dataset.draw = 'ready';

    function watch() {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { threshold: 0.25 });
      io.observe(curve);
    }

    // On the homepage the curve is on screen from the start, so without this the
    // draw would run underneath the preloader and be over before anyone sees it.
    // Hold it until the preloader has left, then let it draw a beat after the
    // header has started sliding in.
    var pre = document.getElementById('jk-preloader');
    if (!pre) { watch(); return; }

    var started = false;
    var begin = function () {
      if (started) return;
      started = true;
      window.setTimeout(watch, 180);
    };
    document.addEventListener('jk:preloader-done', begin, { once: true });
    window.setTimeout(function () {
      if (!document.getElementById('jk-preloader')) begin();
    }, 9000);
  }

  // Masked line reveal for the headline, held until the preloader has left.
  function initTitle(hero) {
    var title = hero.querySelector('.jk-hero__title');
    if (!title || hero.dataset.intro === 'ready') return;

    hero.dataset.intro = 'ready';
    var run = function () {
      window.requestAnimationFrame(function () { hero.classList.add('is-intro-in'); });
    };
    if (reduced) { run(); return; }

    var pre = document.getElementById('jk-preloader');
    if (!pre) { run(); return; }
    document.addEventListener('jk:preloader-done', run, { once: true });
    window.setTimeout(function () {
      if (!document.getElementById('jk-preloader')) run();
    }, 9000);
  }

  function init() {
    document.querySelectorAll('[data-jk-hero]').forEach(function (hero) {
      initTitle(hero);
      initParallax(hero);
      initCurve(hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
